<td class="results-description" colspan="8">
    <div class="results-description__container">
        <label class="results-description__label">
            <span class="results-description-title">Describe results as instructed in "Requirement Responses" (page v)</span>
            <div class="results-description__input-wrapper">
                <div class="results-description__input">
                    <textarea
                        #resultsDescriptionTextarea
                        class="results-description__textarea"
                        [class.results-description__textarea--invalid]="hasValidationError"
                        [disabled]="isInteractionDisabled"
                        [value]="resultsDescription"
                        (input)="onDescriptionInput(resultsDescriptionTextarea.value)"
                        [attr.aria-invalid]="hasValidationError ? 'true' : null"
                        [attr.aria-required]="isDescriptionRequired ? 'true' : null"
                        [attr.required]="isDescriptionRequired ? '' : null"
                    ></textarea>
                    <div class="results-description__error saq-form-field__error" *ngIf="hasValidationError">
                        {{ validationError }}
                    </div>
                </div>
                <div class="results-description__button-group">
                    <button
                        nz-button
                        nzSize="large"
                        nzType="primary"
                        type="button"
                        class="cb4-button results-description__save-button"
                        [disabled]="isInteractionDisabled || isFormComplete || isSaveDisabled"
                        [nzLoading]="isSaving"
                        (click)="onSaveDraftClicked()"
                    >
                        <i nz-icon nzType="save"></i>
                        Save Changes
                    </button>
                    <button
                        nz-button
                        nzSize="large"
                        nzType="primary"
                        type="button"
                        class="cb4-button results-description__save-button"
                        [disabled]="isInteractionDisabled || isFormComplete || isSaveDisabled"
                        [nzLoading]="isSaving"
                        (click)="onSaveClicked()"
                        *ngIf="shouldShowSaveAndMarkReviewedAction"
                    >
                        <i nz-icon nzType="check"></i>
                        Save & Mark as Reviewed
                    </button>
                    <button
                        nz-button
                        nzSize="large"
                        type="button"
                        class="cb4-button results-description__save-button cb4-button--warning"
                        *ngIf="shouldShowNeedsReviewAction"
                        [disabled]="isNeedsReviewDisabled || isInteractionDisabled"
                        [nzLoading]="isMarkingNeedsReview"
                        (click)="onNeedsReviewClicked()"
                    >
                        <i nz-icon nzType="close"></i>
                        Mark as Needs Review
                    </button>
                </div>
            </div>
            <div class="results-description__actions">
                <div class="results-description__follow-up">
                    <nz-container *ngIf="followUpLink">
                        A worksheet has been added to 
                        <a href="" class="results-description__follow-up-link" (click)="onFollowUpLinkClicked($event)">
                            {{ followUpLink.appendixLabel }}
                        </a>
                        corresponding to this requirement
                    </nz-container>
                </div>
                <div
                    class="results-description__last-saved"
                    *ngIf="hasLastSavedInfo && lastSavedDisplayName"
                >
                    <i>Last Saved: {{ lastSavedDisplayName }} on {{ lastSavedAt | date: 'd MMM y \' at \' hh:mm' }}</i>
                </div>
            </div>
        </label>
    </div>
</td>





